(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    /* Custom: show the variant image on the product card when a color swatch is clicked.
     Product cards show a single image, so the card slideshow has no scroller and ignores
     image changes. This switches the visible image directly. */
  (() => {
    if (window.cardSwatchImageSwap) return;
    window.cardSwatchImageSwap = true;

    const showCardMedia = (card, mediaId) => {
      if (!card || !mediaId) return;
      const slides = Array.from(card.querySelectorAll('.card-gallery slideshow-slide[slide-id]'));
      const target = slides.find((slide) => slide.getAttribute('slide-id') === String(mediaId));
      if (!target) return;

      for (const slide of slides) {
        const isTarget = slide === target;
        slide.toggleAttribute('hidden', !isTarget);
        slide.removeAttribute('reveal');
        slide.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      }

      const scroller = target.parentElement;
      if (scroller) scroller.scrollLeft = 0;
    };

    const isCardSwatch = (element) =>
      element instanceof HTMLInputElement && element.closest('product-card swatches-variant-picker-component');

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!isCardSwatch(input)) return;
        showCardMedia(input.closest('product-card'), input.dataset.optionMediaId);
      },
      true
    );

    document.addEventListener(
      'variant:update',
      (event) => {
        const picker = event.target instanceof Element ? event.target.closest('swatches-variant-picker-component') : null;
        if (!picker) return;
        const card = picker.closest('product-card');
        setTimeout(() => {
          const checked = picker.querySelector('input:checked');
          if (checked instanceof HTMLInputElement) showCardMedia(card, checked.dataset.optionMediaId);
        }, 0);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
